// extracted by mini-css-extract-plugin
export var linkText = "_nv-0";